import { Dispatch } from 'redux';
import { History } from 'history';

// Enums
import { PostMessageIncomingAction } from '@/enums/PostMessageAction';

// Strategies
import { ReadyStrategy } from './strategies/ready-strategy';
import { GetBookOfBusinessStrategy } from './strategies/book-of-business-strategy';
import { ContextChangedStrategy } from './strategies/context-changed-strategy';
import { GetPortfoliosStrategy } from './strategies/portfolios-strategy';

// Types
import IncomingPostMessage from '@/types/incoming-post-message';
import { FactsetHouseholds } from '@/types/factset-household';
import { PortfolioFDC3 } from '@/types/portfolio-fdc3';
import { GetAccountPortfoliosStrategy } from './strategies/account-lookup-portfolios-strategy';

export const executePostMessageStrategy = (dispatch: Dispatch, data: IncomingPostMessage, history: History<unknown>) => {
  switch (data.action) {
    case PostMessageIncomingAction.CAPINTEL_READY:
      new ReadyStrategy().execute(dispatch);
      break;

    case PostMessageIncomingAction.CAPINTEL_GET_BOOK_OF_BUSINESS:
      const bookOfBusinessContext = data.context as FactsetHouseholds;
      new GetBookOfBusinessStrategy().execute(dispatch, bookOfBusinessContext);
      break;

    case PostMessageIncomingAction.CAPINTEL_GET_PORTFOLIOS:
      const portfoliosContext = (data.context?.portfolios as PortfolioFDC3[]) ?? [];
      new GetPortfoliosStrategy().execute(dispatch, portfoliosContext, history);
      break;

    case PostMessageIncomingAction.FACTSET_CONTEXT_CHANGED:
      const context = data.context as PortfolioFDC3;
      new ContextChangedStrategy().execute(dispatch, context, history);
      break;

    case PostMessageIncomingAction.FACTSET_ACCOUNT_LOOKUP_PORTFOLIOS:
      // We currently only support a single portfolio in the context since that is what FactSet sends
      const accountLookupPortfolios = (data.context?.portfolios as PortfolioFDC3[]) ?? [];
      new GetAccountPortfoliosStrategy().execute(dispatch, accountLookupPortfolios, history);
      break;
  }
};
